<div class="page">
  <app-project-summary></app-project-summary>
</div>
